import PropTypes from "prop-types";
import dynamic from "next/dynamic";
import { Box, Skeleton } from "@mui/material";
import { mapPublicLegendContent } from "src/components/legend-content";
import { calculateBoundsAndCenter } from "src/utils//bound-calc";

export const OverviewPublicMap = (props) => {
  const { geolocations, selectedStation, isLoading } = props;

  const Map = dynamic(() => import("src/components/map"), {
    ssr: false,
  });

  const mapMarkers = geolocations?.map((item) => {
    return {
      position: [item.latitude, item.longitude],
      popupText: {
        name: item.name,
        x: item.latitude,
        y: item.longitude,
        z: item.elevation,
      },
    };
  });

  const coordinates = mapMarkers?.map((item) => item.position);
  let defaultBounds = [
    [6.208547176, 100.38006988],
    [6.110545874, 100.35489802],
  ];

  const { bounds } = calculateBoundsAndCenter(coordinates, 0.5);
  if (bounds) defaultBounds = bounds;

  const legendContent = mapPublicLegendContent;

  return (
    <Box
      sx={{
        alignItems: "center",
        display: "flex",
        height: props.height ? props.height : "calc(100vh - 180px)",
        width: "100%",
      }}
    >
      {isLoading ? (
        <Skeleton
          variant="rounded"
          width="100%"
          height="100%"
        />
      ) : (
        <Map
          geolocations={geolocations}
          selectedStation={selectedStation}
          defaultBounds={defaultBounds}
          legendContent={legendContent}
          mapControlPosition={"bottomright"}
          isPublic={true}
        />
      )}
    </Box>
  );
};

OverviewPublicMap.propTypes = {
  geolocations: PropTypes.array,
  selectedStation: PropTypes.object,
  isLoading: PropTypes.bool,
};
